import Topic from '@/classes/topic';
import { stripHtml } from '@/utils';

const state = () => ({
  topics: {},
  modalTopics: [],
});

const getters = {
  all: state => {
    return Object.keys(state.topics).map(id => state.topics[id]).sort((a, b) => {
      if (stripHtml(a.title.toLowerCase()) < stripHtml(b.title.toLowerCase())) {
        return -1;
      } else {
        return 1;
      }
    });
  },
  root: (state, getters) => getters['all'].filter(t => t.path.match(/^\d+$/)),
  topics: state => state.topics,
};

const mutations = {
  setTopics: function(state, topics = []) {
    topics.forEach(t => {
      const topic = new Topic(t);
      state.topics[topic.id] = topic;
    });
  },
  reset(state) {
    state.topics = {};
    state.modalTopics = [];
  },
};

const actions = {
  createTopicSession({dispatch, commit, getters, rootGetters}, params) {
    return rootGetters['session/ajax'].post('/topic_sessions', params).then(response => {
      commit('setTopics', response.data.topics);
      return response.data.session;
    });
  },
  load({dispatch, commit, getters, rootGetters}, params) {
    if (params?.ids) {
      const existingIds = getters.all.map( t => t.id );
      params.ids = params.ids.filter( id => !existingIds.includes(id) );
      if (params.ids.length == 0) {
        return;
      }
    }
    return rootGetters['session/ajax'].get('/topics', { params }).then(response => {
      commit('setTopics', response.data.topics);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
